import React from 'react';

function formatWhen(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

/** Horizontal milestone strip for buyer post-agreement pipeline */
export default function InfrastructureLeasingBuyerPostSaleMilestones({ milestones }) {
  if (!Array.isArray(milestones) || milestones.length === 0) return null;
  return (
    <div className="ile-post-sale-milestones mb-4" role="list" aria-label="Lease pipeline progress">
      {milestones.map((m) => {
        const mod =
          m.state === 'done'
            ? 'ile-post-sale-milestones__item--done'
            : m.state === 'current'
              ? 'ile-post-sale-milestones__item--current'
              : 'ile-post-sale-milestones__item--pending';
        return (
          <div key={m.key} className={`ile-post-sale-milestones__item ${mod}`} role="listitem">
            <span className="ile-post-sale-milestones__label">{m.label}</span>
            <span className="ile-post-sale-milestones__meta d-block">{formatWhen(m.completedAt)}</span>
          </div>
        );
      })}
    </div>
  );
}
